<template>
  <div class="mt-5">
    <div v-if="phoneinput == true" class="items-center justify-center">
      <vx-input-group class="mb-3">
        <template slot="prepend">
          <div class="prepend-text bg-primary">
            <span>+91</span>
          </div>
        </template>

        <vs-input
          v-validate="'numeric|length:10'"
          name="phone"
          v-model="phone"
          placeholder="Enter your Mobile Number"
        />
      </vx-input-group>
      <span class="text-danger text-sm">{{ errors.first("phone") }}</span>

      <vs-button
        class="w-full mt-2"
        color="primary"
        type="filled"
        :disabled="!validateForm2"
        @click="submitPhoneNumberAuth"
        >Send OTP
      </vs-button>
      <div id="recaptcha-container"></div>
      <vs-prompt
        @cancel="cancel"
        @accept="loginWithphone"
        title="OTP Verification"
        @close="cancel"
        :is-valid="validateForm3"
        accept-text="Login"
        :active.sync="activePrompt"
      >
        <div class="items-center">
          <span>Enter the OTP sent to {{ phone }}</span>
          <div class="input-wrapper mt-5 items-center justify-center">
            <PincodeInput
              v-if="loginbutton == true"
              v-model="code"
              :length="6"
            />
          </div>
        </div>
      </vs-prompt>
      <!--<div class="input-wrapper mt-5">
        <PincodeInput v-if="loginbutton == true" v-model="code" :length="6" />
        <vs-button
          v-if="loginbutton == true"
          class="mt-2"
          :disabled="!validateForm3"
          @click="loginWithphone"
          >Login</vs-button
        >
      </div>-->

      <!-- <vs-divider>OR</vs-divider>

      <vs-button color="primary" icon="mail" @click="emaillogin"
        >Login with Email</vs-button
      >-->
    </div>
    <div v-if="emailinput == true">
      <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full"
        @keyup.enter="login"
      />
      <span class="text-danger text-sm">{{ errors.first("email") }}</span>

      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6"
        @keyup.enter="login"
      />
      <span class="text-danger text-sm">{{ errors.first("password") }}</span>

      <div class="flex flex-wrap justify-between my-4">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
          >Remember Me</vs-checkbox
        >
        <router-link to="/pages/forgot-password">Forgot Password?</router-link>
      </div>
      <vs-button class="w-full" :disabled="!validateForm" @click="login"
        >Login</vs-button
      >
      <!--<vs-divider>OR </vs-divider>
      <vs-button
        color="primary"
        type="filled"
        icon="mail"
        size="large"
        @click="phonelogin"
        >Login with Phone</vs-button
      >-->
    </div>

    <div
      v-if="socialinput == true"
      id="page-login"
      class="social-login-buttons flex flex-wrap mt-2 items-center justify-center"
    >
      <vs-divider>OR</vs-divider>
      <vx-tooltip text="Login with email">
        <div
          class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-10"
          @click="emaillogin"
          v-if="phoneinput == true"
        >
          <vs-icon icon="mail" class="text-white" size="16px" />
        </div>
      </vx-tooltip>
      <vx-tooltip text="Login with Mobile Number">
        <div
          class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-10"
          @click="phonelogin"
          v-if="emailinput == true"
        >
          <vs-icon icon="phone" class="text-white" size="16px" />
        </div>
      </vx-tooltip>
      <vx-tooltip text="Login with facebook">
        <div
          class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-10"
          @click="loginWithFacebook"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-f"
            class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 264 512"
          >
            <path
              fill="currentColor"
              d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
            ></path>
          </svg>
        </div>
      </vx-tooltip>
      <!-- TWITTER -
      <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithTwitter">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
      </div> -->
      <vx-tooltip text="Login with google">
        <div
          class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
          @click="loginWithGoogle"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="google"
            class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 488 512"
          >
            <path
              fill="currentColor"
              d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
            ></path>
          </svg>
        </div>
      </vx-tooltip>

      <!-- GITHUB -
      <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGithub">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github-alt" class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 512"><path fill="currentColor" d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"></path></svg>
      </div> -->
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import PincodeInput from "vue-pincode-input";

export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      phone: "",
      otp: "",
      emailinput: false,
      phoneinput: true,
      socialinput: true,
      loginbutton: false,
      code: "",
      activePrompt: false,
    };
  },
  components: {
    PincodeInput,
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
    validateForm2() {
      return !this.errors.any() && this.phone.length === 10;
    },
    validateForm3() {
      return !this.errors.any() && this.code.length === 6;
    },
  },
  mounted() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "normal",
        callback: function (response) {
          submitPhoneNumberAuth();
        },
      }
    );
  },
  methods: {
    cancel() {
      this.activePrompt = false;
      this.socialinput = true;
      this.code = "";
    },
    submitPhoneNumberAuth() {
      this.activePrompt = true;
      // We are using the test phone numbers we created before
      // var phoneNumber = document.getElementById("phoneNumber").value;
      this.socialinput = false;
      this.loginbutton = true;
      var phoneNumber = "+91" + this.phone;
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: function (response) {
            submitPhoneNumberAuth();
          },
        }
      );
      var appVerifier = window.recaptchaVerifier;
      firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, appVerifier)
        .then(function (confirmationResult) {
          window.confirmationResult = confirmationResult;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    emaillogin() {
      this.emailinput = true;
      this.phoneinput = false;
    },
    phonelogin() {
      this.emailinput = false;
      this.phoneinput = true;
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        return false;
      }
      return true;
    },
    login() {
      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close,
      };
      this.$store.dispatch("auth/loginAttempt", payload);
    },
    //phone login
    loginWithphone() {
      this.$vs.loading();
      // console.log(this.code);

      // We are using the test code we created before
      // var code = document.getElementById("code").value;
      let thisIns = this;
      confirmationResult
        .confirm(this.code)
        .then((result) => {
          var user = result;
          // console.log(user.user.uid);
          const payload = {
            userDetails: result,
            notify: this.$vs.notify,
            closeAnimation: this.$vs.loading.close,
          };
          if (user.user.uid)
            thisIns.$store.dispatch("auth/loginWithphone", payload);
        })
        .catch((err) => {
          console.log(err);
          thisIns.$vs.notify({
            time: 5000,
            title: "Error",
            text: err.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          this.$vs.loading.close();
          localStorage.removeItem("userInfo");
          this.socialinput = true;
          firebase.auth().signOut();
        });
    },
    // Google login
    loginWithGoogle() {
      this.$store.dispatch("auth/loginWithGoogle", { notify: this.$vs.notify });
    },

    // Facebook login
    loginWithFacebook() {
      this.$store.dispatch("auth/loginWithFacebook", {
        notify: this.$vs.notify,
      });
    },

    // Twitter login
    loginWithTwitter() {
      this.$store.dispatch("auth/loginWithTwitter", {
        notify: this.$vs.notify,
      });
    },

    // Github login
    loginWithGithub() {
      this.$store.dispatch("auth/loginWithGithub", { notify: this.$vs.notify });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    },
  },
};
</script>


<style lang="scss">
.social-login-buttons {
  .bg-facebook {
    background-color: #1551b1;
  }
  .bg-twitter {
    background-color: #00aaff;
  }
  .bg-google {
    background-color: #4285f4;
  }
  .bg-github {
    background-color: #333;
  }
}
input.vue-pincode-input {
  max-width: 50px;
  height: 50px;
  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
  }
  // any styles you want for each cell
}
</style>

